// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__Y_UZ5","insightsList":"newBusinessInsightsMenu_insightsList__2Gc62","active":"newBusinessInsightsMenu_active__2oJhj"};